export const merchantOnboardingHubApiUrl = `${process.env.NEXT_PUBLIC_API_DOMAIN}/merchant-onboardinghub-api`;
